import { DataProviderService } from "../../services/DataProviderService";
import {
  dispatchCloseModal,
  dispatchIsAuthenticated,
} from "./globalStateManagementAction";
import {
  dispatchFetchData,
  dispatchUpdateData,
  FETCH_TYPE_DIGITAL_OFFER_PARTIAL,
  FETCH_TYPE_PARTICIPANTS,
} from "./fetchAction";
import {
  getParsedParticipants,
} from "../../../vendor/utils/DigitalOfferContentUtils";
import { dispatchCheckoutForward } from "./checkoutManagementAction";

/**
 * do something specific for different kinds of errors
 * @param errorStatus
 */
const handleError = (dispatch, errorStatus, fetchType) => {

  switch (errorStatus) {
    case 401:
      dispatch(dispatchIsAuthenticated(false));
      break;

    case "isCanceled":
      //do nothing here
      break;

    default:
      console.warn("error with code ", errorStatus);
      dispatch(dispatchUpdateData({hasLoadingError: true}, fetchType));
  }
};

const updateData = (form, isCheckout) => {
  return dispatch => {
    dispatch(dispatchUpdateData({isLoading: true}, FETCH_TYPE_PARTICIPANTS));
    const dataProvider = new DataProviderService({
      endpoint: '/offer.php/portal-canusa/updateTraveller',
      useCache: false,
      useMock: false,
      useLegacyAPI: true
    });
    dataProvider.setData(form).then(response => {
      if (response.internalType) {
        dispatch(dispatchUpdateData({isLoading: false}, FETCH_TYPE_PARTICIPANTS));
        handleError(dispatch, response.internalType, FETCH_TYPE_PARTICIPANTS);
      } else {
        dispatch(dispatchUpdateData({
          ...getParsedParticipants(response),
          updateComplete: true,
          isLoading: false
        }, FETCH_TYPE_PARTICIPANTS));
        // because of potential references between participants and offerItems, reload all Items
        dispatch(dispatchFetchData(FETCH_TYPE_DIGITAL_OFFER_PARTIAL));
        if (isCheckout) {
          dispatch(dispatchCheckoutForward());
        } else {
          console.log('updateData closeForm');
          dispatch(dispatchCloseModal());
        }

      }
    }).catch(e => {
      handleError(dispatch, e, FETCH_TYPE_PARTICIPANTS)
    })
  }
};



/**
 * generic fetchData action
 *
 * @param fetchType| one of the defined fetchType constants
 * @param silent | set to true if isLoading should not be set in the data while loading
 * @return {function(*): *}
 */
export const dispatchUpdateParticipants = (form, isCheckout) => {
  return (dispatch) => {
    return dispatch(updateData(form, isCheckout))
  }
};
